import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "public-preset-field" }
const _hoisted_2 = {
  key: 0,
  role: "alert"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 1,
  role: "alert"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

import { studioSelectTheme } from "../../../studioSelectTheme";
import "../../../../studioSelect.css";
import { computed, watchEffect, type HTMLAttributes } from "vue";
import type { PerformanceClip } from "../../types/DialogueNode";
import { NSelect } from "naive-ui";
import TypedValueInput from "../../../TypedValueInput.vue";
import { usePublicEventPresets } from "../../../EntityPresetEditor/usePublicEventPresets";
import { getPublicEventArguments, applyPublicEventPreset, isPublicEventArgumentVisible, getPublicEventArgumentReference, syncPublicEventVisibility } from "../../utils/publicEventParameters";
import { PUBLIC_EVENT_PARAM_TYPES, publicEventPresetLabel } from "../../../EntityPresetEditor/publicEventPresets";
import { usePresetReferences } from "../../../EntityPresetEditor/presetReferences";

export default /*@__PURE__*/_defineComponent({
  __name: 'PublicEventClipEditor',
  props: {
    clip: {}
  },
  setup(__props: any) {

const references = usePresetReferences();
const props = __props;
// Naive UI teleports menus to body; keep them inside the Timeline's outside-click boundary.
const clipMenuProps: HTMLAttributes & { "data-clip-editor": string } = { "data-clip-editor": "", class: "studio-select-menu" };
const { availablePresets: presets, ready, error, retry } = usePublicEventPresets();
watchEffect(() => {
  if (ready.value) syncPublicEventVisibility(props.clip, presets.value);
}, { flush: "sync" });
const presetOptions = computed(() => presets.value.filter(preset => preset.name.trim())
  .map(preset => ({ label: publicEventPresetLabel(preset), value: preset.id })));
const selectedPreset = computed(() => {
  const id = props.clip.components.find(item => item.templateId === "public.event")?.properties.presetId;
  return typeof id === "string" && presets.value.some(preset => preset.id === id) ? id : null;
});
const parameters = computed(() => getPublicEventArguments(props.clip));
const visibleParameters = computed(() => parameters.value.filter(param => isPublicEventArgumentVisible(param, parameters.value))
  .map(parameter => ({ parameter, reference: getPublicEventArgumentReference(props.clip, parameter) })));
function applyPreset(id: string) {
  const preset = presets.value.find(item => item.id === id);
  if (preset) applyPublicEventPreset(props.clip, preset);
}
const savedEventName = computed(() => {
  const value = props.clip.components.find(component => component.templateId === "public.event")?.properties.value;
  return typeof value === "string" ? value : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "公共事件预设", -1)),
      _createVNode(_unref(NSelect), {
        "theme-overrides": _unref(studioSelectTheme),
        value: selectedPreset.value,
        options: presetOptions.value,
        disabled: !_unref(ready),
        filterable: "",
        "menu-props": clipMenuProps,
        placeholder: "搜索代号或事件名",
        "aria-label": "公共事件预设",
        "onUpdate:value": applyPreset
      }, null, 8, ["theme-overrides", "value", "options", "disabled"]),
      (_unref(error))
        ? (_openBlock(), _createElementBlock("small", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(error)) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(retry)().catch(() => undefined)))
            }, "重试")
          ]))
        : (_unref(ready) && !presetOptions.value.length)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, "可在「预设设置 → 预设公共事件」中添加事件和参数。"))
          : _createCommentVNode("", true),
      (!selectedPreset.value && savedEventName.value)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, "已保存事件：" + _toDisplayString(savedEventName.value) + "。选择预设后替换。", 1))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleParameters.value, ({ parameter: param, reference }) => {
      return (_openBlock(), _createElementBlock("label", {
        key: param.id,
        class: "public-event-field"
      }, [
        _createTextVNode(_toDisplayString(param.name) + " · " + _toDisplayString(_unref(PUBLIC_EVENT_PARAM_TYPES).find(type => type.value === param.type)?.label) + " ", 1),
        reference
          ? (_openBlock(), _createBlock(_unref(NSelect), {
              key: 0,
              "theme-overrides": _unref(studioSelectTheme),
              value: param.value,
              options: _unref(references).options(reference, param.type),
              filterable: "",
              "menu-props": clipMenuProps,
              disabled: !_unref(references).readyFor(reference),
              "aria-label": param.name + '预设值',
              placeholder: "选择配置记录",
              "onUpdate:value": ($event: any) => (param.value = $event)
            }, null, 8, ["theme-overrides", "value", "options", "disabled", "aria-label", "onUpdate:value"]))
          : _createCommentVNode("", true),
        (reference && _unref(references).errorFor(reference))
          ? (_openBlock(), _createElementBlock("small", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(references).errorFor(reference)) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_unref(references).retryFor(reference).catch(() => undefined))
              }, "重新加载引用", 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        reference
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, "当前值：" + _toDisplayString(param.value || '（空）') + "。选择会复制值；后续修改预设不会改变此动作。", 1))
          : _createCommentVNode("", true),
        (reference && _unref(references).readyFor(reference) && !_unref(references).options(reference, param.type).length)
          ? (_openBlock(), _createElementBlock("small", _hoisted_8, "引用暂无可用记录，请在预设设置中补充或修正值来源。"))
          : _createCommentVNode("", true),
        (!reference || reference === 'entities.guid' || reference === 'entities.entityQuery')
          ? (_openBlock(), _createBlock(TypedValueInput, {
              key: 4,
              modelValue: param.value,
              "onUpdate:modelValue": ($event: any) => ((param.value) = $event),
              "value-type": param.type,
              "aria-label": param.name
            }, null, 8, ["modelValue", "onUpdate:modelValue", "value-type", "aria-label"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 64))
}
}

})